import React from 'react';

const Search = ({ fill = '#404040' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5318 20.4686L16.8378 15.7755C18.1983 14.1421 18.8767 12.047 18.7319 9.92618C18.5871 7.80531 17.6302 5.82191 16.0603 4.38859C14.4904 2.95526 12.4284 2.18235 10.3031 2.23065C8.17785 2.27895 6.15303 3.14474 4.64986 4.64791C3.14669 6.15108 2.2809 8.1759 2.2326 10.3012C2.1843 12.4264 2.95721 14.4885 4.39054 16.0584C5.82387 17.6283 7.80726 18.5852 9.92813 18.73C12.049 18.8748 14.144 18.1963 15.7774 16.8358L20.4706 21.5299C20.5402 21.5995 20.623 21.6548 20.714 21.6925C20.8051 21.7302 20.9026 21.7497 21.0012 21.7497C21.0997 21.7497 21.1973 21.7302 21.2884 21.6925C21.3794 21.6548 21.4621 21.5995 21.5318 21.5299C21.6015 21.4602 21.6568 21.3775 21.6945 21.2864C21.7322 21.1954 21.7516 21.0978 21.7516 20.9992C21.7516 20.9007 21.7322 20.8031 21.6945 20.7121C21.6568 20.621 21.6015 20.5383 21.5318 20.4686ZM3.75119 10.4992C3.75119 9.16421 4.14707 7.85917 4.88877 6.74914C5.63047 5.63911 6.68468 4.77394 7.91808 4.26305C9.15148 3.75216 10.5087 3.61849 11.8181 3.87894C13.1274 4.13939 14.3302 4.78226 15.2742 5.72627C16.2182 6.67027 16.861 7.87301 17.1215 9.18238C17.3819 10.4918 17.2483 11.849 16.7374 13.0824C16.2265 14.3158 15.3613 15.37 14.2513 16.1117C13.1413 16.8534 11.8362 17.2492 10.5012 17.2492C8.71159 17.2473 6.99585 16.5355 5.73041 15.27C4.46497 14.0046 3.75318 12.2888 3.75119 10.4992Z"
        fill={fill}
      />
    </svg>
  );
};

export default Search;
